export const GET_CITIES_BY_UNIQUE_BASE = 'GET_CITIES_BY_UNIQUE_BASE';
export const GET_PRE_REGISTRATIONS = 'GET_PRE_REGISTRATIONS';
